module.exports = __webpack_public_path__ + "static/media/logo2.49ebe6de.png";